module.exports = new __parcel__URL__("fleche-vague.44f035ea.svg").toString();